var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"upload-container"},[_c('a-upload',{ref:"upload",staticClass:"upload-list-inline",attrs:{"fileList":_vm.fileList,"showUploadList":true,"beforeUpload":_vm.beforeUpload,"customRequest":_vm.customRequest,"list-type":"picture"}},[_c('a-button',{attrs:{"size":"small","icon":"cloud-upload","title":"上传图片"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }